<template>
    <div>
        <div ref="pieChart" style="width: 100%; height: 400px;"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            chartData: [
                { tissue: "0d_ESC", count: 6070 },{ tissue: "15d_primitive_cardiomyocite", count: 17136 },{ tissue: "2cell", count: 2998 },
                { tissue: "2d_mesoderm", count: 4742 },{ tissue: "5d_cardiac_mesoderm", count: 8233 },{ tissue: "7d_cardiac_progenitor_cells", count: 8065 },
                { tissue: "80d_ventricular_cardiomyocyte", count: 30694 },{ tissue: "8cell", count: 5300 },{ tissue: "adrenal_gland_male_embryo_97_days", count: 11486 },
                { tissue: "amnion_embryo_16_weeks", count: 35 },{ tissue: "CESC", count: 10819 },{ tissue: "chorion_female_embryo_40_weeks", count: 324 },
                { tissue: "chorion_male_embryo_16_weeks", count: 1459 },{ tissue: "chorionic_villus_embryo_16_weeks", count: 301 },{ tissue: "chorionic_villus_female_embryo_40_weeks", count: 3243 },
                { tissue: "chorionic_villus_male_embryo_16_weeks", count: 804 },{ tissue: "chorionic_villus_male_embryo_38_weeks", count: 791 },{ tissue: "CM", count: 7315 },
                { tissue: "CP", count: 11539 },{ tissue: "DE", count: 2644 },{ tissue: "embryonic_facial_prominence_embryo_10.5_days", count: 2026 },
                { tissue: "embryonic_facial_prominence_embryo_11.5_days", count: 301 },{ tissue: "embryonic_facial_prominence_embryo_12.5_days", count: 987 },
                { tissue: "embryonic_facial_prominence_embryo_13.5_days", count: 2992 },{ tissue: "embryonic_facial_prominence_embryo_14.5_days", count: 2881 },
                { tissue: "embryonic_facial_prominence_embryo_15.5_days", count: 1753 },{ tissue: "ESC", count: 18844 },
                { tissue: "forebrain_embryo_10.5_days", count: 3103 },{ tissue: "forebrain_embryo_11.5_days", count: 488 },
                { tissue: "forebrain_embryo_12.5_days", count: 1945 },{ tissue: "forebrain_embryo_13.5_days", count: 1682 },
                { tissue: "forebrain_embryo_14.5_days", count: 571 },{ tissue: "forebrain_embryo_15.5_days", count: 3407 },
                { tissue: "forebrain_embryo_16.5_days", count: 2359 },{ tissue: "forebrain_postnatal_0_days", count: 952 },
                { tissue: "heart_embryo_10.5_days", count: 1110 }, { tissue: "heart_embryo_11.5_days", count: 1989 },
                { tissue: "heart_embryo_12.5_days", count: 2843 },{ tissue: "heart_embryo_13.5_days", count: 6490 },
                { tissue: "heart_embryo_14.5_days", count: 9422 },{ tissue: "heart_embryo_15.5_days", count: 6131 },
                { tissue: "heart_embryo_16.5_days", count: 6918 },{ tissue: "heart_left_ventricle_male_child_3_years", count: 12139 },
                { tissue: "heart_postnatal_0_days", count: 5981 },{ tissue: "heart_right_ventricle_male_child_3_years", count: 6809 },
                { tissue: "hESC", count: 896 }, { tissue: "hindbrain_embryo_10.5_days", count: 2104 },{ tissue: "hindbrain_embryo_11.5_days", count: 1006 },
                { tissue: "hindbrain_embryo_12.6_days", count: 1281 },{ tissue: "hindbrain_embryo_13.5_days", count: 3167 },{ tissue: "hindbrain_embryo_14.5_days", count: 1227 },
                { tissue: "hindbrain_embryo_15.5_days", count: 2308 },{ tissue: "hindbrain_embryo_16.5_days", count: 1293 },{ tissue: "hindbrain_postnatal_0_days", count: 653 },
                { tissue: "hPGC", count: 370 },{ tissue: "hPGCLC", count: 607 },{ tissue: "intestine_embryo_14.5_days", count: 1877 },
                { tissue: "intestine_embryo_15.5_days", count: 960 },{ tissue: "intestine_embryo_16.5_days", count: 3398 },
                { tissue: "intestine_postnatal_0_days", count: 521 },{ tissue: "kidney_embryo_14.5_days", count: 224 },
                { tissue: "kidney_embryo_15.5_days", count: 3851 },{ tissue: "kidney_embryo_16.5_days", count: 2180 },
                { tissue: "kidney_postnatal_0_days", count: 734 },{ tissue: "KIT", count: 973 },{ tissue: "large_intestine_male_embryo_108_days", count: 13529 },
                { tissue: "left_lung_female_child_16_years", count: 2453 },{ tissue: "limb_embryo_10.5_days", count: 2378 },{ tissue: "limb_embryo_11.5_days", count: 363 },
                { tissue: "limb_embryo_12.5_days", count: 1627 },{ tissue: "limb_embryo_13.5_days", count: 2403 },{ tissue: "limb_embryo_14.5_days", count: 997 },
                { tissue: "limb_embryo_15.5_days", count: 1637 },{ tissue: "liver_embryo_11.5_days", count: 475 },{ tissue: "liver_embryo_12.5_days", count: 1976 },
                { tissue: "liver_embryo_13.5_days", count: 3577 },{ tissue: "liver_embryo_14.5_days", count: 4940 },{ tissue: "liver_embryo_15.5_days", count: 2415 },
                { tissue: "liver_embryo_16.5_days", count: 3515 },{ tissue: "liver_postnatal_0_days", count: 3237 },{ tissue: "lung_embryo_14.5_days", count: 1183 },
                { tissue: "lung_embryo_15.5_days", count: 3628 },{ tissue: "lung_embryo_16.5_days", count: 6650 },{ tissue: "lung_male_child_3_years", count: 4258 },
                { tissue: "lung_postnatal_0_days", count: 1655 },{ tissue: "ME", count: 1590 },{ tissue: "MES", count: 18410 },
                { tissue: "midbrain_embryo_10.5_days", count: 2742 },{ tissue: "midbrain_embryo_11.5_days", count: 405 },{ tissue: "midbrain_embryo_12.5_days", count: 1552 },
                { tissue: "midbrain_embryo_13.5_days", count: 2241 },{ tissue: "midbrain_embryo_14.5_days", count: 1415 },{ tissue: "midbrain_embryo_15.5_days", count: 1922 },
                { tissue: "midbrain_embryo_16.5_days", count: 2394 },{ tissue: "midbrain_postnatal_0_days", count: 846 },{ tissue: "muscle_of_leg_female_embryo_110_days", count: 12660 },
                { tissue: "muscle_of_trunk_female_embryo_115_days", count: 3911 },{ tissue: "neural_tube_embryo_11.5_days", count: 620 },{ tissue: "neural_tube_embryo_12.5_days", count: 274 },
                { tissue: "neural_tube_embryo_13.5_days", count: 3349 },{ tissue: "neural_tube_embryo_14.5_days", count: 525 },{ tissue: "neural_tube_embryo_15.5_days", count: 1469 },
                { tissue: "oocytes", count: 559 },{ tissue: "pancreas_female_child_16_years", count: 3426 },{ tissue: "placenta_embryo_16_weeks", count: 3689 },
                { tissue: "placenta_female_embryo", count: 3905 },{ tissue: "placenta_female_embryo_113_days", count: 10631 },{ tissue: "placenta_male_embryo", count: 2193 },
                { tissue: "placenta_male_embryo_16_weeks", count: 3454 },{ tissue: "placental_basal_plate_female_embryo_40_weeks", count: 1233 },
                { tissue: "placental_basal_plate_male_embryo_38_weeks", count: 114 },{ tissue: "PreME", count: 1350 },{ tissue: "PS", count: 1124 },
                { tissue: "psoas_muscle_male_child_3_years", count: 2157 },{ tissue: "right_lobe_of_liver_female_child_16_years", count: 7923 },{ tissue: "RS", count: 936 },
                { tissue: "sigmoid_colon_male_child_3_years", count: 15862 },{ tissue: "small_intestine_male_child_3_years", count: 17895 },
                { tissue: "small_intestine_male_embryo_108_days", count: 13544 },{ tissue: "Spermatids", count: 4191 },{ tissue: "Spermatocytes", count: 823 },{ tissue: "Spermatogonia", count: 813 },
                { tissue: "spinal_cord_female_embryo_108_days", count: 3002 },{ tissue: "spleen_male_child_3_years", count: 5353 },
                { tissue: "stomach_embryo_14.5_days", count: 275 },{ tissue: "stomach_embryo_15.5_days", count: 2647 },{ tissue: "stomach_embryo_16.5_days", count: 3075 },
                { tissue: "stomach_female_embryo_96_days", count: 13926 }, { tissue: "stomach_male_child_3_years", count: 6996 },{ tissue: "stomach_postnatal_0_days", count: 1648 },
                { tissue: "Thy1", count: 819 },{ tissue: "thymus_female_embryo_110_days", count: 4790 },{ tissue: "thymus_male_child_3_years", count: 3481 },
                { tissue: "trophoblast_female_embryo_20_weeks", count: 5329 },{ tissue: "trophoblast_female_embryo_40_weeks", count: 4326 }
            ]
        };
    },
    mounted() {
        this.renderChart();
    },
    methods: {
        renderChart() {
        // 使用ECharts绘制饼图
        const pieChart = this.$echarts.init(this.$refs.pieChart);

        const option = {
            tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%)",
            },
            series: [
                {
                    name: "Enhancer Number",
                    type: "pie",
                    radius: "80%",
                    data: this.chartData.map((item) => ({
                        name: item.tissue,
                        value: item.count,
                    })),
                    label: {
                        show: false, // 不显示 label
                    },
                    emphasis: {
                        label: {
                            show: true,
                            position: 'center',
                            formatter: '{b}',
                            textStyle: {
                                fontWeight: 'bold',
                                fontSize: 14,
                            },
                        },
                    },
                    color: this.chartData.map(() => getRandomColor()), // 随机生成颜色
                },
            ],
        };
        function getRandomColor() {
            const letters = '0123456789ABCDEF';
            let color = '#';
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        }
        pieChart.setOption(option);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Tissuefig.vue